export const ICONS_URL = "https://signature-icons-ma.s3.amazonaws.com";
export const SCOPE = "https://www.googleapis.com/auth/gmail.settings.basic";
export const CLIENT_ID =
  "1037852130544-doj679d9892mojvb8jvkbs5larlm410o.apps.googleusercontent.com";
export const ALLOWED_DOMAINS = ["steercrm.com", "autoops.com"];
